import {CommonBannerInstall} from './lwCommonBanner'
import {BannerInstall} from "./lwBanner"
import {LwFooterInstall} from './lwFooter';
import {lwBackTopInstall} from './lwBackTop'
import {LottieInstall} from './lwLottie'
import {LwContainerInstall} from './LwContainer'
import {ElLwBreadInstall} from './lwBreadCrumb'
import {OnlineUserListComponentInstall,OnlineUserVideoComponentInstall } from "./otherOnlineUser";
import { ClassActivityJoinComponentInstall, ClassIdCodeJoinComponentInstall } from "./joinClassroom"

import {StudentBannerInstall} from './studentBanner'
import { LwUserInfoInstall } from "./userInfo";
import { LwButtonInstall } from "./lwButton";
import {LwModalInstall} from './lwModal'
import ErrorModal from "./errorModal/index"
import {VideoPlayerComponentInstall} from './twoScreenPlayer'
/**
 * 组件总入口
 * @param {*} Vue 实例
 */
export const ComponentInit = (Vue) => {
  CommonBannerInstall(Vue)
  BannerInstall(Vue)

  StudentBannerInstall(Vue)
  LwUserInfoInstall(Vue)
  LwButtonInstall(Vue)
  LwModalInstall(Vue)

  LwFooterInstall(Vue)
  lwBackTopInstall(Vue)
  LottieInstall(Vue)
  LwContainerInstall(Vue)
  ElLwBreadInstall(Vue)

  OnlineUserListComponentInstall(Vue)
  OnlineUserVideoComponentInstall(Vue)
  ClassActivityJoinComponentInstall(Vue)
  ClassIdCodeJoinComponentInstall(Vue)

  VideoPlayerComponentInstall(Vue)

  Vue.prototype.$ErrorModal = ErrorModal;
};
